import { lazy } from 'react';

const AuthPage = lazy(() => import('pages/auth'));
const LoginPage = lazy(() => import('pages/login'));
const StorePage = lazy(() => import('pages/store'));
const StatsPage = lazy(() => import('pages/stats'));
const ValidateEmailPage = lazy(() => import('pages/validateEmail'));
const ValidatorPage = lazy(() => import('pages/validator'));

export const routes = [
  {
    path: 'auth',
    label: 'Auth',
    page: <AuthPage />
  },
  {
    path: 'login',
    label: 'Login',
    page: <LoginPage />
  },
  {
    path: 'store',
    label: 'Store',
    page: <StorePage />
  },
  {
    path: 'stats',
    label: 'Stats',
    page: <StatsPage />
  },
  {
    path: 'validate-email',
    label: 'Validate Email',
    page: <ValidateEmailPage />
  },
  {
    path: 'validator',
    label: 'Validator',
    page: <ValidatorPage />
  }
];
